export default "/app/global-wrapper-client/static/7bc06d05bf701c81dd699a2f49eed798.woff2";